import { useTV } from "../../../hooks/useTV";
import { useState, useRef, useEffect } from "react";
import useGlobalStore from "../../../store/global.store";
import { useRemote } from "../../../hooks/useRemote";
import VipSubCheck from "./VipSubCheck";

const VipBottomBar = ({ onBackClick }) => {
  const { isTv } = useTV();
  const { updateView } = useRemote();
  const currentView = useGlobalStore((state) => state.currentView);
  // const setSelectedVipDoor = useGlobalStore(
  //   (state) => state.setSelectedVipDoor
  // );
  const selectedVipDoor = useGlobalStore((state) => state.selectedVipDoor);
  // const setShowBottomBar = useGlobalStore((state) => state.setShowBottomBar);
  const isDisabled = selectedVipDoor !== null;

  const [focusedButton, setFocusedButton] = useState("door1");

  const door1Ref = useRef(null);
  const door2Ref = useRef(null);
  const door3Ref = useRef(null);
  const backButtonRef = useRef(null);

  const buttonStyle = isTv
    ? {
        position: "absolute",

        top: "50%",
        transform: "translateY(-50%)",
        marginLeft: "10px",
        border: "6px solid white",
        background: "transparent",
        color: "white",
        fontFamily: "Lato",
        fontSize: "55px",
        padding: "0px 20px",
        borderRadius: "20px",
        fontWeight: "700",
        userSelect: "none",
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
      }
    : {
        position: "absolute",
        top: "68%",
        transform: "translateY(-50%)",
        marginLeft: "10px",
        border: "2px solid white",
        background: "transparent",
        color: "white",
        fontFamily: "Lato",
        fontSize: "40px",
        padding: "0px 20px",
        borderRadius: "20px",
        fontWeight: "700",
        userSelect: "none",
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
      };

  // Auto-focus logic for TV
  useEffect(() => {
    if (!isDisabled && isTv && door1Ref.current) {
      door1Ref.current.focus();
      setFocusedButton("door1");
    }
  }, [isTv, isDisabled]);

  // Handle keyboard navigation
  useEffect(() => {
    const inVipView = currentView && currentView.toLowerCase().includes("vip");
    if (isTv && !isDisabled && inVipView) {
      const handleKeyDown = (e) => {
        const buttons = ["door1", "door2", "door3", "back"];
        const currentIndex = buttons.indexOf(focusedButton);

        if (e.key === "ArrowRight") {
          e.preventDefault();
          // Navigate to next button or wrap to first
          const nextIndex = (currentIndex + 1) % buttons.length;
          const nextButton = buttons[nextIndex];
          setFocusedButton(nextButton);

          // Focus the appropriate button
          if (nextButton === "door1" && door1Ref.current) {
            door1Ref.current.focus();
          } else if (nextButton === "door2" && door2Ref.current) {
            door2Ref.current.focus();
          } else if (nextButton === "door3" && door3Ref.current) {
            door3Ref.current.focus();
          } else if (nextButton === "back" && backButtonRef.current) {
            backButtonRef.current.focus();
          }
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          // Navigate to previous button or wrap to last
          const prevIndex =
            (currentIndex - 1 + buttons.length) % buttons.length;
          const prevButton = buttons[prevIndex];
          setFocusedButton(prevButton);

          // Focus the appropriate button
          if (prevButton === "door1" && door1Ref.current) {
            door1Ref.current.focus();
          } else if (prevButton === "door2" && door2Ref.current) {
            door2Ref.current.focus();
          } else if (prevButton === "door3" && door3Ref.current) {
            door3Ref.current.focus();
          } else if (prevButton === "back" && backButtonRef.current) {
            backButtonRef.current.focus();
          }
        } else if (e.key === "Enter") {
          e.preventDefault();

          // Handle Enter key for the focused button
          if (focusedButton === "door1") {
            handleDoorClick("door1");
          } else if (focusedButton === "door2") {
            handleDoorClick("door2");
          } else if (focusedButton === "door3") {
            handleDoorClick("door3");
          } else if (focusedButton === "back") {
            handleBackClick();
          }
        }
      };

      // Add event listener
      window.addEventListener("keydown", handleKeyDown);

      // Clean up
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTv, focusedButton, isDisabled, currentView]);

  const getButtonPosition = (buttonId) => {
    if (isTv) {
      // TV positions (in % of screen width)
      if (buttonId === "door1") return window.innerWidth * 0.140625;
      if (buttonId === "door2") return window.innerWidth * 0.424479;
      if (buttonId === "door3") return window.innerWidth * 0.703125;
      if (buttonId === "back") return window.innerWidth * 0.9;
    } else {
      // Display positions
      if (buttonId === "door1") return 120;
      if (buttonId === "door2") return 527;
      if (buttonId === "door3") return 920;
      if (buttonId === "back") return 1160;
    }
  };

  // Helper function to get park button styles
  const getParkButtonStyles = (buttonId, baseStyle) => {
    // Only apply focus styles for TV mode
    if (isTv && focusedButton === buttonId && !isDisabled) {
      return {
        ...baseStyle,
        color: "white",
        borderColor: "#3ADF3C",
        outline: "none",
        border: "6px solid #3ADF3C",
        left: getButtonPosition(buttonId),
      };
    }

    return {
      ...baseStyle,
      color: "white",
      borderColor: "white",
      left: getButtonPosition(buttonId),
    };
  };

  const handleDoorClick = (door) => {
    switch (door) {
      case "door3":
        updateView("VIP__multiview");
        break;
      case "door2":
        updateView("VIP_door_2_selector", () => {});
        break;
      case "door1":
        updateView("VIP__piano");
        break;

      default:
        alert("Invalid door");
    }
  };

  const handleBackClick = async () => {
    if (currentView) {
      if (currentView.toLowerCase().includes("vip")) {
        updateView("Home", () => {
          onBackClick();
        });
      }
      return;
    }

    if (!isDisabled && typeof onBackClick === "function") {
      console.log("Back button clicked in VipBottomBar");
      onBackClick();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "2.2%",
        display: "flex",
        justifyContent: "space-around",
        width: "100vw",
        zIndex: 110,
        height: "90px",
      }}
    >
      <button
        id="parkHopButton"
        ref={door1Ref}
        onClick={() => handleDoorClick("door1")}
        onContextMenu={(e) => e.preventDefault()}
        onFocus={() => !isDisabled && setFocusedButton("door1")}
        onBlur={() => !isDisabled && setFocusedButton(null)}
        tabIndex={isDisabled ? -1 : 0}
        style={getParkButtonStyles("door1", buttonStyle)}
      >
        DOOR 1
      </button>

      <button
        id="changeRideButton"
        ref={door2Ref}
        onClick={() => handleDoorClick("door2")}
        onContextMenu={(e) => e.preventDefault()}
        onFocus={() => !isDisabled && setFocusedButton("door2")}
        onBlur={() => !isDisabled && setFocusedButton(null)}
        tabIndex={isDisabled ? -1 : 0}
        style={getParkButtonStyles("door2", buttonStyle)}
      >
        DOOR 2
      </button>

      <button
        id="door3Button"
        ref={door3Ref}
        onClick={() => handleDoorClick("door3")}
        onContextMenu={(e) => e.preventDefault()}
        onFocus={() => !isDisabled && setFocusedButton("door3")}
        onBlur={() => !isDisabled && setFocusedButton(null)}
        tabIndex={isDisabled ? -1 : 0}
        style={getParkButtonStyles("door3", buttonStyle)}
      >
        DOOR 3
      </button>

      <button
        id="backButton"
        ref={backButtonRef}
        onClick={handleBackClick}
        onContextMenu={(e) => e.preventDefault()}
        onFocus={() => !isDisabled && setFocusedButton("back")}
        onBlur={() => !isDisabled && setFocusedButton(null)}
        tabIndex={isDisabled ? -1 : 0}
        style={getParkButtonStyles("back", buttonStyle)}
      >
        X
      </button>

      <VipSubCheck />
    </div>
  );
};

export default VipBottomBar;
